import { ReactComponent as Max } from "images/max.svg";
import { classNames } from "lib/classNames";
import { useCallback, useContext, useMemo } from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import useScrollDirection from "../../hooks/useScrollDirection";
import { MainLayoutContext } from "../../layouts/MainLayout";
import logo from "./../../images/logo.svg";
import cls from "./header.module.css";
import { PopupMenu } from "./popupMenu/PopupMenu";

// Константы для навигации
const NAV_ITEMS = [
  { path: "/", label: "Главная" },
  { path: "/products", label: "Продукция" },
  { path: "/our-clients", label: "Наши клиенты" },
  { path: "/contacts", label: "Контакты" },
];

// Константы для контактов
const CONTACTS = {
  phone: "+7(914)705-76-99",
  max: "https://max.ru/u/f9LHodD0cOKRvF7YfifHFJcNEZuts2CYjs8OV8T6DjV0iBk9euRYsbHfoyU",
  telegram: "https://t.me/+79147057699",
};

const Header = () => {
  const { mobileMenu, setMobileMenu } = useContext(MainLayoutContext);
  const location = useLocation();
  const scrollDirection = useScrollDirection();

  // Получаем текущий путь из location
  const currentPath = location.pathname;

  // Мемоизация обработчиков
  const handleMenu = useCallback(() => {
    setMobileMenu((prev) => !prev);
  }, [setMobileMenu]);

  // Вычисляем классы для header
  const headerClasses = useMemo(() => {
    const classes = [cls.header];

    if (scrollDirection.hide) {
      classes.push(cls.header_hide);
    }

    if (scrollDirection.direction === "up" && scrollDirection.hide) {
      classes.push(cls.header_sticky);
    }

    return classes.join(" ");
  }, [scrollDirection.hide, scrollDirection.direction]);

  // Проверяем активность ссылки
  const isLinkActive = useCallback(
    (path) => {
      return currentPath === path;
    },
    [currentPath],
  );

  return (
    <header className={headerClasses}> 
      <div className={cls.wrapper}>
        {/* Логотип */}
        <Link
          to="/"
          className={classNames(
            cls.a_wrapper,
            { [cls["logo_active"]]: isLinkActive("/") },
            [cls["link_logo"]],
          )}
          aria-current={isLinkActive("/") && "page"}
        >
          <img className={cls.logo} src={logo} alt="Примпиво" />
        </Link>

        {/* Навигация */}
        <nav className={cls.link}>
          {NAV_ITEMS.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={classNames(
                cls.a_wrapper,
                { [cls["link_active"]]: isLinkActive(path) },
                [cls.link_a, cls.header_hover],
              )}
              aria-current={isLinkActive(path) ? "page" : undefined}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Контакты и меню */}
        <div className={cls.icons}>
          {/* Социальные сети */}
          <a
            className={cls.icons_a}
            target="_blank"
            rel="noopener noreferrer"
            href={CONTACTS.max}
            aria-label="Max"
          >
            <Max className={classNames(cls.icon, {}, [cls.header_hover])} />
          </a>

          <a
            className={cls.icons_a}
            target="_blank"
            rel="noopener noreferrer"
            href={CONTACTS.telegram}
            aria-label="Telegram"
          >
            <FaTelegramPlane
              className={classNames(cls.icon, {}, [cls.header_hover])}
            />
          </a>

          {/* Телефон */}
          <a
            href={`tel:${CONTACTS.phone.replace(/[^\d+]/g, "")}`}
            className={classNames(cls.number_phone, {}, [cls.header_hover])}
            aria-label="Позвонить"
          >
            {CONTACTS.phone}
          </a>

          {/* Кнопка меню */}
          <div className={cls.popup_menu}>
            <PopupMenu
              mobileMenu={mobileMenu}
              items={NAV_ITEMS}
              onMenu={handleMenu}
              tabIndex={0}
              path={currentPath}
              aria-label="Открыть или закрыть меню"
            />
          </div>
        </div>
      </div>
      <div className="line" />
    </header>
  );
};

export default Header;
